import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {message} from "antd";
import {createProductServiceRepository} from "../data/repositories";
import {GET_STORE_SERVICES_RQ_KEY} from "../../../react-query-hooks/store/services/constants";

/**
 * Legacy-compatible delete hook. Preserves the `{storeServiceId, currentPage}`
 * argument shape, the per-page list invalidation, and the error toast of the
 * original, while routing through the feature repository (always v2).
 *
 * @deprecated Use useDeleteProductService from features/product-services instead.
 */
export const useDeleteStoreServiceApi = () => {
  const queryClient = useQueryClient();
  const repository = createProductServiceRepository();

  return useMutation<
    void,
    AxiosError<{message: string}>,
    {storeServiceId: number; currentPage: number}
  >({
    mutationFn: ({storeServiceId}) => repository.remove(storeServiceId),
    onError: (error: AxiosError<{message: string}>) => {
      message.error(error.message);
    },
    onSettled: (_data, _error, values) =>
      queryClient.invalidateQueries({
        queryKey: [GET_STORE_SERVICES_RQ_KEY, {page: values.currentPage}],
      }),
  });
};
